"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.skips = void 0;
exports.skips = {
    headings: {
        skipOrders: "Skip Orders",
        search: "Search Skip Orders",
        purchaseOrders: "Purchase Orders",
        createPO: "Create Purchase Order",
        editPO: "Edit Purchase Order",
        emails: "Emails",
    },
    table: {
        ref: "Job Ref",
        postcode: "Postcode",
        status: "Status",
        movementType: "Movement Type",
        supplier: "Supplier",
        poCount: "POs",
        totalCost: "Supplier Cost",
        latestPOStatus: "Latest PO Status",
        actions: "Actions",
        poNumber: "PO Number",
        sku: "SKU",
        type: "Type",
        deliveryDate: "Delivery",
        collectionDate: "Collection",
        cost: "Cost",
        notes: "Notes",
        date: "Date",
    },
    form: {
        labels: {
            supplierRef: "Supplier Ref",
            supplierName: "Supplier Name",
            supplierCost: "Supplier Cost",
            supplierEmail: "Supplier Email",
            sku: "SKU",
            type: "Type",
            status: "Status",
            deliveryDate: "Delivery Date",
            collectionDate: "Collection Date",
            manualEntry: "Manually Enter",
            backToList: "Back to list",
            supplierNotes: "Supplier Notes",
            internalNotes: "Internal Notes",
            createdBy: "Created By",
        },
        placeholders: {
            poNumber: "Search PO number...",
            supplierRef: "Search supplier...",
            supplierName: "Enter supplier name",
            supplierCost: "Enter cost",
            supplierEmail: "Enter supplier email",
            sku: "Enter SKU",
            supplierNotes: "Notes visible to supplier",
            internalNotes: "Internal notes only",
            supplierRefManual: "Type supplier ref",
        },
    },
    filters: {
        all: "All",
        status: "Status",
        movementType: "Movement Type",
        dateFrom: "Date From",
        dateTo: "Date To",
        poNumber: "PO Number",
        latestPOStatus: "Latest PO Status",
    },
    jobStatuses: {
        New: "New",
        Started: "Started",
        Completed: "Completed",
        Cancelled: "Cancelled",
    },
    movementTypes: {
        NEW: "New",
        EXCHANGE: "Exchange",
        COLLECTION: "Collection",
    },
    buttons: {
        search: "Search",
        reset: "Reset",
        createPO: "Create PO",
        edit: "Edit",
        save: "Save",
        cancel: "Cancel",
        view: "View",
        send: "Send",
        emails: "Emails",
        resend: "Resend",
    },
    success: {
        createPO: "Purchase order created",
        updatePO: "Purchase order updated",
        sendPO: "Purchase order sent to supplier",
        sendCollectionRequest: "Collection request email sent to supplier",
    },
    emails: {
        poEmail: "PO Email",
        collectionRequestEmail: "Collection Request Email",
        sendTo: "Send to",
        noSupplierEmail: "No supplier email configured",
        collectionRequestSending: "Collection request email will be sent to the supplier",
    },
    customerPrice: "Customer Price: {{price}}",
    businessCustomer: "Business Customer",
    priceWarning: "Supplier cost ({{supplierCost}}) exceeds customer price ({{customerPrice}})",
    errors: {
        noData: "No skip orders found",
        noPOs: "No purchase orders for this job",
        error: "Something went wrong. Please try again.",
        requiredFields: "Please fill in all required fields.",
        dateToBeforeDateFrom: "Date To must be on or after Date From",
    },
    statuses: {
        Draft: "Draft",
        Sent: "Sent",
        Confirmed: "Confirmed",
        "Collection Requested": "Collection Requested",
        Complete: "Complete",
        Cancelled: "Cancelled",
        "Wasted Journey": "Wasted Journey",
    },
    types: {
        Delivery: "Delivery",
        Collection: "Collection",
        Exchange: "Exchange",
    },
};
